(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name      : 'MarketingPlansAddVendorCoops',
		submitted : false,
		serialized: null
	};

	var $form,
	    _resetVendor,
	    _selectVendor;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		$form.submit(function formSubmitted(e) {
			form.submitted = true;
		});

		// Method for adding a new vendor coop
		$form.find('.add-vendor').on('click', function addVendor(e) {
			var cur_parent = $(this).parents('.vendor-coop-fields').find('.add-vendor');
			var next_parent = $(this).parents('.vendor-coop-fields').next('.vendor-coop-fields');

			e.preventDefault();

			next_parent.find('input, select, textarea').each(function enableInputs(index, el) {
				$(el).prop('disabled', false);
			});
			next_parent.removeClass('hidden');
			cur_parent.addClass('hidden');
		});

		// hide vendor coop field - disable all its form fields so they won't be submitted to server
		$form.find('.remove-vendor').on('click', function removeVendor(e) {
			var cur_parent = $(this).parents('.vendor-coop-fields');
			var prev_parent = $(this).parents('.vendor-coop-fields').prev('.vendor-coop-fields').find('.add-vendor');
			var $vendorContainer = $(this).parents('.vendor-coop-fields');
			var $effortContainer = $(this).parents('.effort');
			var cur_coop_id;
			var cur_effort_id;

			e.preventDefault();

			Adzuki.CustomConfirm({
				body   : 'Are you sure you want to remove this Vendor Co-op?',
				confirm: function removeVendorCoop() {
					// clear all the form fields within this div
					$vendorContainer.find('input, select, textarea').each(function clearInput(index, el) {
						// $(el).val($(el).data('original-value'));
						$(el).prop('disabled', true);
					});

					// hide the form
					cur_parent.addClass('hidden');
					prev_parent.removeClass('hidden');

					cur_coop_id = $vendorContainer.data("vendor-coop-id");
					cur_effort_id = $effortContainer.data("effort-id");

					if (cur_coop_id !== '') {
						Adzuki.Ajax.get('/MarketingPlans/deleteCoop/' + cur_coop_id + "/" + cur_effort_id).then(function success(response) {
							if (response) {
								form.submitted = true; // prevent before unload check from firing on refresh
								location.reload();
							}
						});
						// Adzuki.StatusMessage('Success', 'The Coop has been deleted');
					}
				}
			});

			
		});

		// Toggle use vendor fields
		$form.find('.tie-to-new-existing').on('change', function change(e) {
			var parent = $(this).parents('.effort');

			if ($(e.target).val() === '0') {
				parent.find('.vendor-coops').addClass('hidden');
				
			} else {
				parent.find('.vendor-coops').removeClass('hidden');

			}
		});

		// Toggle new vendor fields
		$form.find('.tie-to-vendor-coop').on('change', function change(e) {
			if ($(e.target).val() === '0') {
				$(this).parents('.vendor-coop-fields').find('.new-vendor').addClass('hidden');
				$(this).parents('.vendor-coop-fields').find('.existing-vendor').removeClass('hidden');

			} else {
				$(this).parents('.vendor-coop-fields').find('.existing-vendor').addClass('hidden');
				$(this).parents('.vendor-coop-fields').find('.new-vendor').removeClass('hidden');

			}
		});

		$form.find('.existing-vendor-coop').on('change', function coopChange(e) {
			if ($(e.target).val() === '') {
				$(this).parents('.vendor-coop-fields').find('.existing-vendor .coop-amount').addClass('hidden');
				$(this).parents('.vendor-coop-fields').find('.existing-vendor .price-field').val('');

			} else {
				$(this).parents('.vendor-coop-fields').find('.existing-vendor .coop-description').removeClass('hidden');
				$(this).parents('.vendor-coop-fields').find('.existing-vendor .coop-amount').removeClass('hidden');
				$(this).parents('.vendor-coop-fields').find('.existing-vendor .price-field').val('');

			}
		});

		$.each($form.find('.effort'), function assignKeyToVendorField(i) {

			$.each($(this).find('.new-vendor'), function assignKeyToVendorField(key) { 
				
				Adzuki.Typeahead(
					'#marketingplansaddvendorcoops-marketing_effort-' + i + '-vendor-'+ key + '-vendor_search',
					'/MarketingPlans/search',
					function select(item, $self, typeahead) {
						typeahead.setHiddenValue(item.id);

						_selectVendor(item, i, key);
					}
				);

				$('#reset-vendor').click(function resetClicked() {
					$('#vendorcoop-name').val('');
					$('#vendorcoop-cruise_line_id').val('');
				});

				// Vendor select logic
				$('#marketingplansaddvendorcoops-marketing_effort-' + i + '-vendor-'+ key + '-vendor_select').on('change', function change(e) {
					var vendor_id = $(e.target).val();

					$('#marketingplansaddvendorcoops-marketing_effort-' + i + '-vendor-'+ key + '-vendor_id').val(vendor_id);

					Adzuki.Ajax.get('/MarketingPlans/getVendor/' + vendor_id).then(function success(vendor) {
						_selectVendor(vendor);
					});
				});

				// Reset vendor information when vendor typeahead is reset
				$('#marketingplansaddvendorcoops-marketing_effort-' + i + '-vendor-'+ key + '-vendor_search').on('ta.reset', function reset(e) {
					_resetVendor();
				});

				// Toggle vendor search and select
				$form.find('.select-vendor').on('click', function click(e) {
					var parent = $(this).parents('.new-vendor');

					e.preventDefault();

					parent.find('.vendor-search .reset-typeahead a').trigger('click');

					parent.find('.vendor-search').addClass('hidden');
					parent.find('.vendor-select').removeClass('hidden');
				});

				$form.find('.search-vendor').on('click', function click(e) {
					var parent = $(this).parents('.new-vendor');
					e.preventDefault();

					parent.find('.vendor-search .reset-typeahead a').trigger('click');

					parent.find('.vendor-search').removeClass('hidden');
					parent.find('.vendor-select').addClass('hidden');

					$('#marketingplansaddvendorcoops-marketing_effort-' + i + '-vendor-'+ key + '-vendor_select').val('');
				});
			});
		});

		form.serialized = $form.serialize();

		// if user tries to leave this page, besides via a form submission, throw a warning that their info hasn't been saved
		$(window).on('beforeunload', function before() {
			var newSerializedForm = $form.serialize();
			if (form.submitted === false && form.serialized !== newSerializedForm) {
				return 'Are you sure you want to leave before finishing your Marketing Plan?';
			}

			return undefined; // do not show dialog if form hasn't changed at all
		});
	};

	_resetVendor = function _resetVendor()
	{
		$form.find('.vendor-details').addClass('hidden');
	};

	_selectVendor = function _selectVendor(vendor, i, key)
	{
		_resetVendor();

		$('#marketingplansaddvendorcoops-marketing_effort-' + i + '-vendor-'+ key + '-vendor_id').val(vendor.id);

		if (vendor.primary_component_type === 'cruise') {
			$('#vendorcoop-cruise_line_id').val(vendor.primary_component_existing_vendor_id);

			Adzuki.Ajax.get('/MarketingPlans/getLoyaltyProgramNameByVendorId/' + vendor.id).then(function success(program) {
				$('#vendorcoop-name').val(program.program);
			});
		}

		$form.find('.vendor-details').removeClass('hidden');

	};

}(jQuery, window.Adzuki || {}));